import VideoPlayer from './versions/0.0.1';

export default VideoPlayer;
